import styled from 'styled-components';

const MyInfoListWrap = styled.div`
    color: #666666;
    margin-top: 1.25rem;
    margin-bottom: 0.5rem;
`;

export default MyInfoListWrap;